<template>
  <div class="white-container photo-edit">
    <el-form ref="form" :model="form" :rules="rules" label-width="110px" size="small" style="margin-top:20px">
      <el-form-item label="活动名称" prop="name" style="width: 460px">
        <el-input v-model="form.name" maxlength="14" placeholder="请输入活动名称，最多不超过14个字符" style="width: 360px;" />
      </el-form-item>
      <el-form-item label="上传方式" prop="type">
        <el-radio v-model="form.type" :label="0" @change="handleCheckRule">照片</el-radio>
        <el-radio v-model="form.type" :label="1" @change="handleCheckRule">链接</el-radio>
      </el-form-item>
      <el-form-item label="活动城市" prop="cityId" style="width:300px">
        <el-select v-model="form.cityId" popper-class="_uaEventCityId_" placeholder="请选择城市">
          <el-option v-for="item in citySelectVO" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="活动日期" prop="beginTime" style="width: 300px">
        <el-date-picker v-model="form.beginTime" type="date" placeholder="请选择活动时间" prefix-icon="el-icon-date" class="custom-date" value-format="yyyy-MM-dd HH:mm:ss" />
      </el-form-item>
      <el-form-item v-if="form.type === 1" label="活动照片链接" prop="input">
        <el-input v-model="form.input" placeholder="请输入活动照片链接" style="width: 360px;" @change="handleInputChange" />
      </el-form-item>

      <el-form-item v-if="form.type === 0" label="上传图片/视频" prop="url">
        <div class="coupon-upload flex">
          <el-upload ref="uploader" class="uploader" action="" :on-change="handlePushUploader" :auto-upload="false" accept="image/*" multiple>
            <el-button slot="trigger" size="small">选择文件</el-button>
            <el-button style="margin-left: 10px;" size="small" type="primary" @click="submitUpload">上传到服务器</el-button>
          </el-upload>
          <div class="coupon_tip upload_tips" style="color:#BBBBBB;margin-left:10px">支持上传*.png、*.jpg，大小不超过5M</div>
        </div>
      </el-form-item>
      <div v-if="form.url.length && form.type === 0" class="image-list flex">
        <div v-for="(item,index) in form.url" :key="index" class="image-item">
          <div class="img-wrap">
            <img :src="item" alt="">
            <div class="mask">
              <i class="el-icon-close close-icon" @click="remove(index)" />
              <div class="operation">
                <el-button type="text" style="display:block;color:#fff;text-decoration:underline;width:100%;" @click="onPreview(index)">查看图片</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-form-item label="上传图片" class="upload-wrap" prop="coverImage">
        <div class="flex">
          <UploadImage :url="form.coverImage.coverPhoto || ''" :limit-size="2" save-path="ua_activity/uastar/" title="照片封面" size-tips="489px*450px" @upload="handleCoverPhoto" />
          <UploadImage :url="form.coverImage.shareCardImage || ''" :limit-size="2" save-path="ua_activity/uastar/" title="小程序分享卡片" size-tips="500px*400px" @upload="handleShareCardImage" />
        </div>

      </el-form-item>
      <el-form-item style="width:100%;margin-top:80px;margin-left:-50px">
        <div class="flex btns">
          <el-button type="info" @click="cancel">取消</el-button>
          <el-button type="primary" @click="submit">保存</el-button>
        </div>
      </el-form-item>
    </el-form>
    <!--图片预览-->
    <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="list" />
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="goBack" />
  </div>
</template>
<script>
import { ActivitySpecialPhoto } from '@/model/ActivitySpecialPhoto';
import UploadImage from '@/components/UploadImage';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import Dialog from '@/components/Dialog';
import { mapState } from 'vuex';
export default {
  components: { UploadImage, ElImageViewer, Dialog },
  data() {
    const checkPhotos = (rule, value, callback) => {
      if (value.coverPhoto && value.shareCardImage) {
        callback();
      } else {
        callback(new Error('请上传图片'));
      }
    };
    return {
      id: '',
      isAssociation: 0, // 是否 -> 社群活动相册1 / 专题活动相册0
      form: new ActivitySpecialPhoto(),
      name: '',
      type: undefined, // 用户获取详情
      showViewer: false,
      list: [],
      formDialogShow: false,
      information: {},
      fileList: [],
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
        ],
        type: [
          { required: true, message: '请选择上传方式', trigger: 'blur' },
        ],
        url: [
          { required: true, message: '请上传图片', trigger: 'blur' },
        ],
        input: [
          { required: true, message: '请输入活动照片链接', trigger: 'blur' },
        ],
        beginTime: [
          { required: true, message: '请选择活动时间', trigger: 'blur' },
        ],
        cityId: [
          { required: true, message: '请选择活动城市', trigger: 'blur' },
        ],
        coverImage: [
          { required: true, message: "请上传图片", trigger: "blur" },
          { validator: checkPhotos, trigger: 'change' },
        ],
      },
    };
  },
  computed: {
    ...mapState('activity', ['citySelectVO']),
  },
  watch: {
    form: {
      handler(val) {
        if (val.url && Array.isArray(val.url)) {
          this.list = [...val.url];
          this.initList = [...val.url];
        }
      },
      deep: true,
    },
  },
  mounted() {
    const { query } = this.$route;
    if (query.isAssociation && Number(query.isAssociation) === 8) {
      this.isAssociation = 1;
    }
    if (query.id) {
      this.id = Number(query.id);
      this.fetchData();
    }
  },
  methods: {
    fetchData() {
      this.$Api.activity.specialHighlightMomentDetails(this.id).then(res => {
        this.form = new ActivitySpecialPhoto(res);
      });
    },
    handleInputChange() {
      if (this.form.input) {
        this.form.url = [this.form.input];
      }
    },
    handleCheckRule() {
      if (this.form.type === 0) {
        this.form.url = [];
      } else {
        this.form.url = this.form.input ? [this.form.input] : [];
      }
      this.$nextTick(() => {
        this.$refs.form.clearValidate(['url', 'input']);
      });
    },
    handleCoverPhoto(url) {
      this.form.coverImage.coverPhoto = url;
      this.$refs.form.validateField('coverImage');
    },
    handleShareCardImage(url) {
      this.form.coverImage.shareCardImage = url;
      this.$refs.form.validateField('coverImage');
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.id) {
            this.$Api.activity.updateHighlightMomentOfSpecial({ ...this.form, id: this.id, highlightMomentType: this.isAssociation }).then(res => {
              this.$message.success('修改成功');
              this.goBack();
            });
          } else {
            this.$Api.activity.addSpecialHighlightMoment({ ...this.form, highlightMomentType: this.isAssociation }).then(res => {
              this.$message.success('新增成功');
              this.goBack();
            });
          }
        } else {
          return false;
        }
      });
    },
    handlePushUploader(file) {
      this.uploader(file);
    },
    uploader(file) {
      this.fileList.push(file.raw);
    },
    submitUpload() {
      const types = ['png', 'jpg', 'jpeg'];
      const savePath = 'ua_activity/images/';
      if (this.isAssociation === 0) {
        this.$Api.uploadFile.specialEventAlbumUploadFiles(this.fileList, savePath, types, true).then(data => {
          const { uploadSuccessList, uploadFailList } = data;
          this.$refs.uploader.clearFiles();// 清空文件列表
          const tempArr = [];
          // 上传成功
          uploadSuccessList.map((item) => {
            tempArr.push(item.describe);
          });
          this.form.url = [...this.form.url, ...tempArr];
          this.fileList = [];
          this.$refs.form.validateField('url');
          // 上传失败
          if (uploadFailList.length) {
            let errMsg = '';
            uploadFailList.map((item) => {
              errMsg = errMsg + (`${item.name}上传失败，失败原因：${item.describe}<br />`);
            });
            this.$message.error({
              dangerouslyUseHTMLString: true,
              message: errMsg,
            });
          }
        });
      } else {
        this.$Api.uploadFile.uploadImageList(this.fileList, savePath, types, false).then(data => {
          const { uploadSuccessList, uploadFailList } = data;
          this.$refs.uploader.clearFiles();// 清空文件列表
          const tempArr = [];
          // 上传成功
          uploadSuccessList.map((item) => {
            tempArr.push(item.describe);
          });
          this.form.url = [...this.form.url, ...tempArr];
          this.fileList = [];
          this.$refs.form.validateField('url');
          // 上传失败
          if (uploadFailList.length) {
            let errMsg = '';
            uploadFailList.map((item) => {
              errMsg = errMsg + (`${item.name}上传失败，失败原因：${item.describe}<br />`);
            });
            this.$message.error({
              dangerouslyUseHTMLString: true,
              message: errMsg,
            });
          }
        });
      }
    },
    onPreview(index) {
      this.showViewer = true;
      const tempSrcList = [...this.initList];
      const temp = [];
      for (let i = 0; i < index; i++) {
        temp.push(tempSrcList.shift());
      }
      this.list = tempSrcList.concat(temp);
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false;
    },
    remove(index) {
      const images = [...this.form.url];
      images.splice(index, 1);
      this.form.url = images;
      this.$refs.form.validateField('url');
    },
    cancel() {
      this.formDialogShow = true;
      const _this = this;
      this.information = {
        operation: 'delete',
        icon: 'warn',
        subTitle: `是否放弃${_this.id ? '编辑' : '新增'}，返回上级页面？`,
      };
    },
    goBack() {
      this.$router.back(-1);
    },

  },
};

</script>
<style lang="less" scoped>
.btns {
  align-items: center;
  justify-content: center;
}
</style>
<style lang="less">
.photo-edit {
  .upload-wrap {
    display: flex;
    flex-direction: column;
    .el-form-item__label {
      text-align: left;
      font-family: "Noto Sans SC";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 23px;
      color: #494949;
      margin-bottom: 20px;
    }
    .el-form-item__content {
      margin-left: unset !important;
    }
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 30px;
  }
  .image-list {
    flex-wrap: wrap;
    .image-item {
      width: 150px;
      height: 150px;
      text-align: center;
      margin-right: 10px;
      margin-bottom: 10px;
      .img-wrap {
        border: 1px dashed #e5e5e5;
        width: 100%;
        height: 100%;
        position: relative;
        &:hover {
          .mask {
            display: block;
          }
        }
        img {
          width: 100%;
          height: 100%;
        }
        .cover {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 24px;
          line-height: 24px;
          font-size: 12px;
          background: rgba(0, 0, 0, 0.5);
          color: #fff;
        }
        .mask {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 100;
          background: rgba(0, 0, 0, 0.5);
          color: #fff;
          display: none;
          .close-icon {
            position: absolute;
            right: 10px;
            top: 10px;
            font-size: 20px;
            cursor: pointer;
          }
          .operation {
            width: 100%;
            height: auto;
            margin-top: 30px;
          }
        }
      }
    }
  }
}
</style>

